export default __webpack_public_path__ + "static/rahimi-5b943288eef6a662dc00e0d37de887a1.jpg";